import React, { ComponentProps } from 'react'

import { Global } from '@emotion/react'

type Props = Pick<ComponentProps<typeof Global>, 'styles'>

export const EmotionProvider = React.memo((props: Props) => {
  return <Global {...props} />
})
